export interface CheckboxColors {
  selectedBackground?: string | null;
  selectedBorder?: string | null;
}

export function buildCheckboxCssRules(
  s: string,
  colors: CheckboxColors | null | undefined,
): string[] {
  if (!colors) return [];

  const bg = colors.selectedBackground || undefined;
  const border = colors.selectedBorder || undefined;

  if (!bg && !border) return [];

  const selectors = [
    `${s}[data-ui="item-checkbox"]`,
    `${s}[data-ui="bundle-group-checkbox"]`,
    // Radio button options (e.g. multiple-choice step) reuse the same
    // "selected" design tokens, so they track selection colors too.
    `${s}[data-ui="option"]`,
  ];
  const selectorList = selectors.join(", ");

  const vars: string[] = [];
  if (bg) {
    vars.push(`--redo-colors-background-bg-alternate: ${bg};`);
    vars.push(`--redo-colors-background-bg-secondary-solid: ${bg};`);
  }
  if (border) {
    vars.push(`--redo-colors-border-border-primary: ${border};`);
    // The border color also controls the checkmark icon color
    vars.push(`--redo-colors-foreground-fg-on-brand: ${border};`);
  }

  return [`${selectorList} { ${vars.join(" ")} }`];
}
